export const PREFIX_URL = '/proprietarios';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
